/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanningResponseDto { 
    Result?: PlanningResponseDto.ResultEnum;
    AdditionalInfo?: string;
}
export namespace PlanningResponseDto {
    export type ResultEnum = 'Success' | 'Error' | 'AtLeastOneNonPlannableAssignment' | 'EventDateCheckFailed' | 'NeedMoreLoadingUnits';
    export const ResultEnum = {
        Success: 'Success' as ResultEnum,
        Error: 'Error' as ResultEnum,
        AtLeastOneNonPlannableAssignment: 'AtLeastOneNonPlannableAssignment' as ResultEnum,
        EventDateCheckFailed: 'EventDateCheckFailed' as ResultEnum,
        NeedMoreLoadingUnits: 'NeedMoreLoadingUnits' as ResultEnum
    };
}


